import { render, staticRenderFns } from "./ModalContactEdit.vue?vue&type=template&id=8d30f2aa&scoped=true&"
import script from "./ModalContactEdit.vue?vue&type=script&lang=js&"
export * from "./ModalContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d30f2aa",
  null
  
)

export default component.exports